import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Loader2, Lock, LogIn } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { useAdminAuth } from '../context/AdminAuthContext';

export function AdminLoginPage() {
  const navigate = useNavigate();
  const { isAuthenticated, login, isLoggingIn, error, clearError } =
    useAdminAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    clearError();
    login(username, password)
      .then(() => navigate('/admin', { replace: true }))
      .catch(() => {});
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-white via-red-50 to-brand-gold-light/20 px-4">
      <Card className="w-full max-w-md border-2 border-brand-red/20 shadow-xl">
        <CardHeader className="bg-red-50/40">
          <CardTitle className="flex items-center gap-2 text-brand-red">
            <Lock className="h-5 w-5" />
            Admin Login
          </CardTitle>
          <p className="mt-1 text-sm text-gray-600">
            เข้าสู่ระบบด้วย username / password จาก env
          </p>
        </CardHeader>
        <CardContent>
          <form className="space-y-4" onSubmit={handleSubmit}>
            <label className="block text-sm font-medium text-gray-700">
              Username
              <input
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none focus:border-brand-red"
                required
              />
            </label>
            <label className="block text-sm font-medium text-gray-700">
              Password
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 outline-none focus:border-brand-red"
                required
              />
            </label>
            {error ? (
              <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-brand-red">
                {error}
              </p>
            ) : null}
            <Button type="submit" size="lg" className="w-full" disabled={isLoggingIn}>
              {isLoggingIn ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  กำลังเข้าสู่ระบบ...
                </>
              ) : (
                <>
                  <LogIn className="h-4 w-4" />
                  เข้าสู่ระบบ
                </>
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
